import { call, put, takeEvery, select } from 'redux-saga/effects';
import { getLeadsMotHistory } from '../../requests/get_leads_mot_history_request';
import { getLeadsMotHistoryRequestSuccess, getLeadsMotHistoryRequestFailure } from '../actions/get_leads_mot_history.actions';
import { GET_LEADS_MOT_HISTORY_REQUEST } from '../constants/cap.constants';
import { message_error } from '../../../../../components/Message';
import { getBlemishReportRequest } from '../actions/questions_actions/get_blemish_report.actions';

function* getLeadsMotHistoryRequest({ bike_details }) {
    const { result, options, error } = yield call(getLeadsMotHistory, bike_details);
    if (result) {
        yield put(getLeadsMotHistoryRequestSuccess(options.mot_history));
        if (!options.mot_history.length) {
            message_error('No Mot History Available!');
        }
        const { Leads: { Lead_profile: { Lead_general: { root_id } } } } = yield select();

        yield put(getBlemishReportRequest(root_id, 'rag_rating'));
    } else {
        yield put(getLeadsMotHistoryRequestFailure(error));
        message_error(error.message);
    }
}

export default function* getLeadsMotHistorySaga() {
    yield takeEvery(GET_LEADS_MOT_HISTORY_REQUEST, getLeadsMotHistoryRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/get_leads_mot_history.saga.js